import script from "./MoreProductInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoreProductInfo.vue?vue&type=script&lang=ts&setup=true"

import "./MoreProductInfo.vue?vue&type=style&index=0&id=63fa6186&lang=css"

const __exports__ = script;

export default __exports__